import { render, staticRenderFns } from "./SharedRow.vue?vue&type=template&id=53b5349d&scoped=true"
import script from "./SharedRow.vue?vue&type=script&lang=js"
export * from "./SharedRow.vue?vue&type=script&lang=js"
import style0 from "./SharedRow.vue?vue&type=style&index=0&id=53b5349d&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5349d",
  null
  
)

export default component.exports